import { createSlice } from "@reduxjs/toolkit";


const sliderSlice = createSlice({
  name: "slider",
  initialState: {
    images: [],
    loading: false,
  },

  reducers: {
    sliderRequested: (slider, action) => {
      slider.loading = true;
    },

    sliderReceived: (slider, action) => {
      slider.images = action.payload;
      slider.loading = false;
    },

    sliderRequestFailed: (slider, action) => {
      slider.loading = false;
    },
  },
});

export default sliderSlice;
const { sliderRequestFailed, sliderReceived, sliderRequested } =
  sliderSlice.actions;

export const loadBanner = () => async (dispatch) => {
  dispatch(sliderRequested());
  try {
    const baseURL = window.cfg.serverUrl4;
    const lang = localStorage.getItem("language") === "en" ? 'en-us' : 'ar-AE';
    const itemId = '3A3d0c5b6d-bbd4-4fc0-b26c-6720c4a8f486';
    const apiEndpoint = `${baseURL}delivery/api/v2/media?fetch=children%${itemId}`;

    const response = await fetch(apiEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': lang
      }
    });

    const data = await response.json();

    // Construct full URL for slider component
    const originUrl = new URL(baseURL).origin;
    const formattedImages = data.items.map(item => {
      const updatedUrl = item.url.replace('/media/', '/TahbeerUmbracoMedia/');
      return {
        ...item,
        fullUrl: updatedUrl.startsWith('/') ? originUrl + updatedUrl : originUrl + '/' + updatedUrl
      };
    });

    dispatch(sliderReceived(formattedImages));
  } catch (error) {
    console.error("Failed to fetch banners:", error);
    dispatch(sliderRequestFailed());
  }
};
